"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToBool = stringToBool;
function stringToBool(string) {
  switch (string.toLowerCase()) {
    case "false":
    case "no":
    case "0":
    case "":
      return false;
    default:
      return true;
  }
}
//# sourceMappingURL=stringToBool.js.map